import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  ListSubheader,
  Menu,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { Link } from "react-router-dom";
import axios from "axios";
import { useMessage } from "../../../../components/Header";
import LeaveViewPage from "./LeaveViewPage";
import FilterListIcon from "@mui/icons-material/FilterList";
import { TfiViewList } from "react-icons/tfi";
import { useTheme } from "../../../../style/theme";
import { LuCalendarDays, LuLayoutList } from "react-icons/lu";
import { FiGrid } from "react-icons/fi";
import { IoFilter } from "react-icons/io5";
import { HiDotsHorizontal } from "react-icons/hi";
import { CiExport, CiImport } from "react-icons/ci";
import ApplyLeaves from "./ApplyLeaves";
import { SearchIcon, X } from "lucide-react";
import { IoMdClose } from "react-icons/io";
import dayjs from "dayjs";
import ExportModal from "../../../../components/ExportModal";
import CustomImport from "../../../../components/CustomImport";
import ImportModal from "../../../../components/ImportModal";
import { toast } from "react-toastify";
import GridView from "./GridView";
import * as XLSX from "xlsx";
import ApplyLeaveModal from "../../../../components/ApplyLeaveModal";

const LeaveAppPage = ({ isteam = false }) => {
  const [LeaveApplications, seLeaveApplications] = useState([]);
  const [changeView, setChangeView] = useState(false);
  // const errorHandler = useErrorHandler();
  const { mode } = useTheme();
  const [view, setView] = useState("card");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const isMenuopen = Boolean(menuAnchor);
  const [exportOpen, setExportOpen] = useState(false);
  const [leavedata, setLeaveData] = useState();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    PagesLenght: 1,
    totalPages: 0,
  });

  const [rows, setRows] = useState(0);
  const [pages, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [leavetype, setLeavetype] = useState([]);
  const [openImportModal, setOpenImportModal] = useState(false);

  const [filteredRequests, setFilteredRequests] = useState([]);
  const [filteredRequestslist, setFilteredRequestsList] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [openApply, setOpenApply] = useState(false);
  let currentOrg = JSON.parse(localStorage.getItem("org"));

  const [filtervalue, setFilterValue] = useState("allrequest"); // initial value same as defaultValue

  console.log(LeaveApplications, "currentOrgcurrentOrg");

  const LeaveType = useCallback(async () => {
    try {
      const response = await axios.get(
        `/hr/attendance/leaves-types?orgId=${currentOrg?._id}`
      );
      setLeavetype(response.data.leaveTypes);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const fetchLeaveApplication = useCallback(async function () {
    try {
      const response = await axios.get(
        `/hr/attendance/leaves?searchBy=status&search=Pending&orgId=${currentOrg?._id}`
      );
      seLeaveApplications(response.data.leaves);
      setFilteredRequests(response.data.leaves);
    } catch (e) {
      console.log(e);
    }
  }, []);

  let currentEmp =
    currentOrg?.type == "Member"
      ? JSON.parse(localStorage.getItem("emp"))
      : null;

  const LeaveDetails = async () => {
    const response = await axios.get(
      `/employee/leaves/${currentEmp?._id}?page=${
        pages + 1
      }&pageSize=${rowsPerPage}`
    );
    const { leaves, pageData } = response.data;
    setLeaveData(leaves);
    setFilteredRequestsList(leaves);
    setRows(pageData.totalData); // used for showing count

    setPaginationModel({
      totalPages: pageData.totalPages,
      PagesLenght: pageData.currentPage,
      pageSize: pageData.pageSize,
    });
  };

  const LeaveDetailsAdmin = useCallback(async () => {
    try {
      if (currentOrg?.type === "Owner") {
        const response = await axios.get(
          `/hr/attendance/leaves?page=${pages + 1}&pageSize=${rowsPerPage}`
        );
        const { leaves, pageData } = response.data;
        setLeaveData(leaves);
        setFilteredRequestsList(leaves);
        setPaginationModel({
          totalPages: pageData.totalPages,
          PagesLenght: pageData.currentPage,
          pageSize: pageData.pageSize,
        });
        setRows(pageData.totalData); // used for showing count
      }
    } catch (e) {
      console.log(e);
    }
  }, [pages, rowsPerPage]);

  useEffect(() => {
    if (currentOrg?.type == "Owner") {
      fetchLeaveApplication();
      LeaveDetailsAdmin();
    } else if (currentOrg?.type == "Member") {
      LeaveDetails();
    }
    LeaveType();
  }, [LeaveType, pages, rowsPerPage]);

  const { showError, showSuccess } = useMessage();
  const [acceptLoading, setAcceptLoading] = useState(false);
  const acceptLeave = useCallback(
    async function (id) {
      setAcceptLoading(true);
      try {
        const res = await axios.post(`/hr/attendance/leaves/approve/${id}`);
        fetchLeaveApplication();
        LeaveDetailsAdmin();
        const { success, message } = res.data;
        if (success) return showSuccess(message);
        showError(message);
      } catch (e) {
        console.log(e);
      } finally {
        setAcceptLoading(false);
      }
    },
    [fetchLeaveApplication, showSuccess, showError, LeaveDetails]
  );

  const rejectLeave = useCallback(
    async function (id) {
      try {
        const res = await axios.post(`/hr/attendance/leaves/deny/${id}`);
        fetchLeaveApplication();
        LeaveDetailsAdmin();
        const { success, message } = res.data;
        if (success) return showSuccess(message);
        showError(message);
      } catch (e) {
        showError(e);
      }
    },
    [fetchLeaveApplication, showSuccess, showError, LeaveDetails]
  );

  const [leaveModal, setleaveModal] = useState(false);
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  // const [filter, setFilter] = useState("");

  const FilterDrawer = () => {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [employeeSearch, setEmployeeSearch] = useState("");
    const [filter, setFilter] = useState(""); // Empty by default
    const [typeFilter, setTypeFilter] = useState([]); // Empty by default
    const [isCustomDate, setIsCustomDate] = useState(false);

    useEffect(() => {
      const today = new Date();
      let from = "";
      let to = "";

      const formatDate = (date) => date.toLocaleDateString("en-CA");

      switch (filter) {
        case "Today":
          from = to = formatDate(today);
          break;

        case "Yesterday":
          const yest = new Date(today);
          yest.setDate(today.getDate() - 1);
          from = to = formatDate(yest);
          break;

        case "This Month":
          from = formatDate(new Date(today.getFullYear(), today.getMonth(), 1));
          to = formatDate(
            new Date(today.getFullYear(), today.getMonth() + 1, 0)
          );
          break;

        case "Last Month":
          from = formatDate(
            new Date(today.getFullYear(), today.getMonth() - 1, 1)
          );
          to = formatDate(new Date(today.getFullYear(), today.getMonth(), 0));
          break;

        case "This Year":
          from = formatDate(new Date(today.getFullYear(), 0, 1));
          to = formatDate(new Date(today.getFullYear(), 11, 31));
          break;

        case "Last Year":
          from = formatDate(new Date(today.getFullYear() - 1, 0, 1));
          to = formatDate(new Date(today.getFullYear() - 1, 11, 31));
          break;

        case "Custom":
          setIsCustomDate(true);
          return;

        default:
          return;
      }

      setFromDate(from);
      setToDate(to);
      setIsCustomDate(false);
    }, [filter]);

    const applyFilters = () => {
      if (filter === "Custom" && (!fromDate || !toDate)) {
        toast.error("Please select both From and To dates.");
        return;
      }

      let filtered = [...leavedata];

      // 📅 Date filter (only if fromDate & toDate available)
      if (fromDate && toDate) {
        const from = new Date(fromDate);
        const to = new Date(toDate);
        to.setHours(23, 59, 59, 999); // end of day

        filtered = filtered.filter((req) => {
          const created = new Date(req.createdAt);
          return created >= from && created <= to;
        });
      }

      // 📌 Leave Type filter (if selected)
      if (typeFilter?.length > 0) {
        filtered = filtered.filter((req) => {
          const leaveTypeId =
            typeof req.leaveType === "object"
              ? req.leaveType?._id
              : req.leaveType;

          // Check for "Compensatory Off" special case
          const hasCompOffSelected = typeFilter.includes("__noType__");

          // Match if leaveType is null/undefined and comp-off selected
          if (!leaveTypeId && hasCompOffSelected) return true;

          // Match if leaveTypeId exists in selected filters
          return leaveTypeId && typeFilter.includes(leaveTypeId);
        });
      }

      setFilteredRequests(filtered);
      setFilteredRequestsList(filtered);
      setOpenFilterDrawer(false);
    };

    const resetFilters = () => {
      setFromDate("");
      setToDate("");
      // setEmployeeSearch("");
      setFilter("");
      setTypeFilter([]);
      setFilteredRequests(LeaveApplications);
      setFilteredRequestsList(leavedata);
    };

    return (
      <Drawer
        anchor="right"
        open={openFilterDrawer}
        onClose={() => setOpenFilterDrawer(false)}
      >
        <div
          style={{ backgroundColor: mode === "light" ? "#fff" : "#141414" }}
          className="w-72 p-4"
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Filter</h2>
            <button
              onClick={() => setOpenFilterDrawer(false)}
              className="border-none outline-none"
            >
              <X size={20} />
            </button>
          </div>

          {/* Period Selection */}
          {/* Period Selection */}
          <label className="block text-sm font-medium mb-2 text-[#666666]">
            Period
          </label>
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className={`w-full text-sm rounded px-3 py-2 outline-none border ${
              mode === "light"
                ? "bg-white text-black border-gray-300"
                : "bg-[#1e1e1e] text-white border-gray-600"
            }`}
          >
            <option value="" disabled>
              Select...
            </option>
            <option value="Yesterday">Yesterday</option>
            <option value="Today">Today</option>
            <option value="This Month">This Month</option>
            <option value="This Year">This Year</option>
            <option value="Last Month">Last Month</option>
            <option value="Last Year">Last Year</option>
            <option value="Custom">Custom</option>
          </select>

          {/* From Date */}
          <div className="mt-4">
            <label className="block text-sm font-medium text-[#666666] mb-2">
              From
            </label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              disabled={!isCustomDate}
              className={`w-full text-sm border rounded px-3 py-1 bg-[#eeeef1] text-[#333] ${
                !isCustomDate ? "opacity-60 cursor-not-allowed" : ""
              }`}
            />
          </div>

          {/* To Date */}
          <div className="mt-4">
            <label className="block text-sm font-medium text-[#666666] mb-2">
              To
            </label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              disabled={!isCustomDate}
              className={`w-full text-sm border rounded px-3 py-1 bg-[#eeeef1] text-[#333] ${
                !isCustomDate ? "opacity-60 cursor-not-allowed" : ""
              }`}
            />
          </div>

          <div className="mt-4">
            <label className="block text-sm text-[#666666] font-medium mb-2 mt-1">
              Leave Type
            </label>
            <Select
              multiple
              value={typeFilter} // now an array of selected leaveType _id's
              onChange={(e) => setTypeFilter(e.target.value)}
              input={<OutlinedInput />}
              renderValue={(selected) => (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {selected?.map((id) => {
                    if (id === "__noType__") {
                      return (
                        <Chip
                          key={id}
                          label="Compensatory Off"
                          onDelete={() =>
                            setTypeFilter((prev) =>
                              prev.filter((item) => item !== id)
                            )
                          }
                        />
                      );
                    }

                    const type = leavetype?.find((lt) => lt._id === id);
                    return (
                      <Chip
                        key={id}
                        label={type?.name}
                        onDelete={() =>
                          setTypeFilter((prev) =>
                            prev.filter((item) => item !== id)
                          )
                        }
                      />
                    );
                  })}
                </div>
              )}
              fullWidth
              sx={{
                backgroundColor: mode === "light" ? "#fff" : "transparent",
                minHeight: "20px",
                p: 0,
              }}
            >
              <MenuItem value="__noType__">Compensatory Off</MenuItem>
              {leavetype?.map((option) => (
                <MenuItem key={option._id} value={option._id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>

        {/* Action Buttons */}
        <div
          style={{ backgroundColor: mode === "light" ? "#fff" : "#141414" }}
          className="flex items-end h-full pb-4 justify-start px-5 space-x-2"
        >
          <Button
            variant="contained"
            sx={{ backgroundColor: "#0088ff" }}
            onClick={applyFilters}
          >
            Apply
          </Button>
          <Button variant="outlined" onClick={resetFilters}>
            Reset
          </Button>
        </div>
      </Drawer>
    );
  };

  const LeaveModal = ({ leaveModal, setleaveModal }) => {
    const [leaveType, setLeaveType] = useState("Compensatory Off");
    const [email, setEmail] = useState("");
    const [reason, setReason] = useState("");
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [search, setSearch] = useState("");
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [teamEmail, setTeamEmail] = useState("");
    const { mode } = useTheme();
    const namesOptions = [
      { value: "1 Tanya gwilsbry", label: "Compensatory Off" },
    ];
    return (
      <Modal open={leaveModal} onClose={() => setleaveModal(false)}>
        <Box className="flex justify-center items-center">
          <Box
            sx={{
              backgroundColor: mode === "dark" ? "#141414" : "white",
            }}
            className=" rounded-lg w-screen h-[90vh]"
          >
            {/* Header Section */}
            <div className="flex justify-between items-center p-3 border-b">
              <Typography variant="h6" className="font-semibold">
                Apply Leave
              </Typography>
              <IconButton
                onClick={() => setleaveModal(false)}
                sx={{
                  backgroundColor: mode === "light" ? "#dcdcdc" : "",
                  p: "5px",
                  borderRadius: "5px",
                }}
              >
                <IoMdClose size={18} />
              </IconButton>
            </div>

            <div
              style={{
                backgroundColor: mode === "dark" ? "#141414" : "#edf0f4",
              }}
              className="relative h-full"
            >
              <div className="p-4 h-full relative">
                {/* Form Section */}
                <form
                  style={{
                    backgroundColor: mode === "dark" ? "#141414" : "white",
                  }}
                  className="mt-4 flex flex-col gap-y-5 p-4 w-[70%] rounded-lg"
                >
                  <h2 className="text-[16px] font-semibold mb-2">Leave</h2>
                  <hr />

                  {/* Leave Type */}
                  <div className="flex items-center w-full">
                    <label className="text-gray-600 font-medium text-[15px] w-[20%]">
                      Leave Type <span className="text-red-500">*</span>
                    </label>
                    <div className="w-[80%]">
                      <Select
                        className={`${
                          mode === "light" ? "bg-white" : "bg-[#141414]"
                        }`}
                        fullWidth
                        size="small"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        displayEmpty
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              backgroundColor:
                                mode === "dark" ? "#141414" : "#ffffff",
                            },
                          },
                        }}
                      >
                        {/* Search Bar in Dropdown */}
                        <ListSubheader
                          style={{
                            backgroundColor:
                              mode === "ligth" ? "white" : "transparent",
                          }}
                        >
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="Search..."
                            autoFocus
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon fontSize="small" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </ListSubheader>

                        {/* Filtered Categories */}
                        {categories.filter((cat) =>
                          cat.toLowerCase().includes(search.toLowerCase())
                        ).length > 0 ? (
                          categories
                            .filter((cat) =>
                              cat.toLowerCase().includes(search.toLowerCase())
                            )
                            .map((cat) => (
                              <MenuItem key={cat} value={cat}>
                                {cat}
                              </MenuItem>
                            ))
                        ) : (
                          <ListSubheader
                            style={{
                              backgroundColor:
                                mode === "ligth" ? "white" : "transparent",
                            }}
                            className=""
                          >
                            <MenuItem>Select</MenuItem>
                          </ListSubheader>
                        )}
                      </Select>
                    </div>
                  </div>

                  {/* Date Pickers (Start & End Date Side by Side) */}
                  <div className="flex items-center w-full">
                    <label className="text-gray-600 font-medium w-[20%] text-[15px]">
                      Date <span className="text-red-500">*</span>
                    </label>
                    <div className="flex gap-4 w-[80%]">
                      <TextField
                        size="small"
                        type="date"
                        fullWidth
                        variant="outlined"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        size="small"
                        type="date"
                        fullWidth
                        variant="outlined"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>
                  </div>

                  {/* Team Email ID */}
                  <div className="flex items-center w-full">
                    <label className="text-gray-600 text-[15px] font-medium w-[20%]">
                      Team Email ID
                    </label>
                    <div className="w-[80%]">
                      <TextField
                        size="small"
                        fullWidth
                        variant="outlined"
                        value={teamEmail}
                        onChange={(e) => setTeamEmail(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Reason for Leave */}
                  <div className="flex items-start w-full">
                    <label className="text-gray-600 font-medium w-[20%] text-[15px]">
                      Reason for Leave
                    </label>
                    <div className="w-[80%]">
                      <TextField
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={3}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div
                style={{
                  backgroundColor: mode === "dark" ? "#141414" : "#ffffff",
                }}
                className="absolute bottom-0 gap-2 flex w-full p-3 h-fit"
              >
                <Button variant="outlined" onClick={() => setleaveModal(false)}>
                  Cancel
                </Button>
                <Button variant="contained" color="primary">
                  Submit
                </Button>
              </div>
            </div>
          </Box>
        </Box>
      </Modal>
    );
  };

  const calculateLeaveDays = (dates) => {
    if (dates.length < 2) {
      return 1;
    }
    const startDate = new Date(dates[0].year, dates[0].month - 1, dates[0].day);
    const endDate = new Date(
      dates[dates.length - 1].year,
      dates[dates.length - 1].month - 1,
      dates[dates.length - 1].day
    );
    const diffTime = Math.abs(endDate - startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Add 1 to include both start and end days
    return diffDays;
  };

  const mappedLeaveData = leavedata?.map((row, index) => {
    return {
      "Emp ID": index + 1,
      "Emp Name": currentOrg?.type === "Owner" ? row.fullName : undefined,
      "Leave Type": row?.leaveType,
      From: `${row?.dates?.[0]?.year}-${row?.dates?.[0]?.month}-${row?.dates?.[0]?.day}`,
      To:
        row?.dates?.length > 1
          ? `${row?.dates[row.dates.length - 1]?.year}-${
              row?.dates[row.dates.length - 1]?.month
            }-${row?.dates[row.dates.length - 1]?.day}`
          : "-",
      Days: calculateLeaveDays(row.dates),
      Reason: row.reason,
      "Applied On": new Date(row.createdAt).toLocaleDateString(),
      Status: row.status,
    };
  });

  const currentOwner =
    currentOrg?.type === "Owner"
      ? JSON.parse(localStorage.getItem("org"))
      : null;

  const id = currentEmp?._id != null ? currentEmp?._id : currentOwner?.userId;

  const handleClose = () => {
    setOpenImportModal(false);
    setSelectedFile(null);
  };

  const handleDone = async () => {
    if (!selectedFile) {
      alert("No file selected");
      return;
    }

    try {
      const data = await selectedFile.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      console.log("Parsed Data:", jsonData);

      for (const row of jsonData) {
        const startDate = new Date(row?.From);
        const endDate = row?.To ? new Date(row?.To) : null;

        const formattedDates = endDate
          ? [
              {
                year: startDate?.getFullYear(),
                month: startDate?.getMonth() + 1,
                day: startDate?.getDate(),
              },
              {
                year: endDate?.getFullYear(),
                month: endDate?.getMonth() + 1,
                day: endDate?.getDate(),
              },
            ]
          : [
              {
                year: startDate?.getFullYear(),
                month: startDate?.getMonth() + 1,
                day: startDate?.getDate(),
              },
            ];

        const payload = {
          leaveType: row["Leave Type"], // e.g. 'Sick Leave' (must match backend names or IDs)
          reason: row["Reason"] || "Imported", // fallback if missing
          teamEmail: row["Team Email"] || undefined,
          dates: formattedDates,
          compensatoryReq: [], // if you have mapping here
        };

        try {
          const res = await axios.post(`/employee/leaves?empId=${id}`, payload);
          if (res.data.success) {
            console.log("Leave imported:", payload);
          } else {
            console.warn("Failed leave import:", res.data.message);
          }
        } catch (err) {
          console.error("Error importing row:", row, err);
        }
      }

      showSuccess("Leave data imported successfully!");
      handleClose();
    } catch (err) {
      console.error("File parse error", err);
      showError("Something went wrong while parsing the file.");
    }
  };

  const handleChange = (event) => {
    setFilterValue(event.target.value);
    console.log("Selected:", event.target.value); // 👈 optional: log selected value
  };

  return (
    <Box className="p-3 relative">
      <Box
        className="w-full ml-2 md:ml-0 rounded-lg mb-4 pb-5 h-[670px] relative"
        // sx={{
        //   // backgroundColor: 'background.bond',
        //   overflowY: "scroll",
        //   "&::-webkit-scrollbar": {
        //     display: "none",
        //   },
        //   "-ms-overflow-style": "none",
        //   "scrollbar-width": "none",
        // }}
      >
        <div className="w-full mb-3 flex flex-col md:flex-row gap-3 justify-between md:items-center ">
          <div className="flex flex-col  sm:flex-row gap-3 sm:items-center">
            {/* <div>
              <FormControl>
                <Select
                  style={{
                    height: "32px",
                    width: "250px",
                    backgroundColor: mode === "light" ? "#fff" : "",
                    color: mode === "dark" ? "#A5A5A5" : "",
                  }}
                  defaultValue="tableView"
                >
                  <MenuItem value="tableView">Table View</MenuItem>
                  <MenuItem value="Leave">Leave</MenuItem>
                  <MenuItem value="approverView">Approver View</MenuItem>
                  <div className="w-full ">
                    <Button
                      sx={{ width: "100%" }}
                      // onClick={() => {
                      //   setCreateTableViewModal(true);
                      // }}
                      variant="outlined"
                    >
                      Create Table View
                    </Button>
                  </div>
                </Select>
              </FormControl>
            </div>
            <div className="flex gap-2">
              <div>
                <Button variant="outlined">Edit</Button>
              </div>
              <div>
                <Button variant="outlined" color="error">
                  Delete
                </Button>
              </div>
            </div> */}
          </div>

          <div className="flex  gap-3 sm:items-center flex-col sm:flex-row mt-3">
            <FormControl sx={{ width: "200px" }}>
              <Select
                value={filtervalue}
                onChange={handleChange}
                style={{
                  height: "34px",
                  width: "200px",
                  padding: "0px",
                  backgroundColor: mode === "light" ? "#fff" : "",
                  color: mode === "dark" ? "#A5A5A5" : "",
                }}
              >
                <MenuItem value={"allrequest"}>All Requests</MenuItem>
                <MenuItem value={"approved"}>Approved</MenuItem>
                <MenuItem value={"rejected"}>Rejected</MenuItem>
                <MenuItem value={"pending"}>Pending</MenuItem>
                <MenuItem value={"cencelled"}>Cancelled</MenuItem>
              </Select>
            </FormControl>
            <div className="flex gap-2 items-center">
              <div
                onClick={() => setOpenFilterDrawer(true)}
                className={`cursor-pointer relative h-fit group p-2 rounded-md ${
                  mode === "light" ? "bg-[#fff]" : ""
                }`}
              >
                <IoFilter />
              </div>

              {openFilterDrawer && (
                <FilterDrawer
                  openFilterDrawer={openFilterDrawer}
                  setOpenFilterDrawer={setOpenFilterDrawer}
                />
              )}

              <div>
                <div
                  className={`relative h-fit cursor-pointer group p-1 rounded-md ${
                    mode === "light" ? "bg-[#fff]" : ""
                  }`}
                  id="basic-button"
                  aria-controls={isMenuopen ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={isMenuopen ? "true" : undefined}
                  onClick={(event) => {
                    setMenuAnchor(event.currentTarget);
                  }}
                >
                  <HiDotsHorizontal className="text-2xl" />
                </div>
                <Menu
                  id="basic-menu"
                  anchorEl={menuAnchor}
                  open={isMenuopen}
                  onClose={() => {
                    setMenuAnchor(null);
                  }}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem>
                    <div
                      onClick={() => setOpenImportModal(true)}
                      className="flex flex-row gap-3 justify-between items-center"
                    >
                      <CiImport className="text-2xl" />
                      <h1>Import</h1>
                    </div>
                  </MenuItem>
                  <MenuItem>
                    <div
                      onClick={() => setExportOpen(true)}
                      className="flex flex-row gap-3 justify-between items-center"
                    >
                      <CiExport className="text-2xl" />
                      <h1>Export</h1>
                    </div>
                  </MenuItem>
                  {/* <MenuItem>
                    <div className="flex flex-row gap-3 justify-between items-center">
                      <CiExport className="text-2xl" />
                      <h1>History Export</h1>
                    </div>
                  </MenuItem> */}
                </Menu>
              </div>
            </div>
          </div>
        </div>

        <div className="flex  justify-end items-center w- mb-3 pt-3 pe-3">
          {currentOrg.type == "Owner" ? (
            <>
              <div
                className={`rounded-md flex items-center gap-3  ${
                  mode === "light" ? "bg-[#fff]" : ""
                }`}
              >
                <div
                  className="relative group p-2 rounded-md"
                  style={{ border: view === "card" ? "1px solid #0088ff" : "" }}
                  // onClick={()=>handleClose("card")}
                >
                  <FiGrid
                    size={17}
                    className="cursor-pointer"
                    onClick={() => setView("card")}
                    color={view === "card" ? "#0088ff" : ""}
                  />
                  <span className="absolute top-10 left-1/2 w-[max-content] -translate-x-1/2 text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                    Grid view
                  </span>
                </div>
                <div
                  className="relative group p-2 rounded-md"
                  style={{
                    border: view === "list" ? "1px solid #0088ff" : "",
                  }}
                  // onClick={() => handleClose("table")}
                >
                  <TfiViewList
                    size={17}
                    className="cursor-pointer"
                    onClick={() => setView("list")}
                    color={view === "list" ? "#0088ff" : ""}
                  />
                  <span className="absolute top-10 left-1/2 -translate-x-1/2 w-[max-content] text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                    List view
                  </span>
                </div>
              </div>
              <Button
                variant="contained"
                onClick={() => setOpenApply(!openApply)}
                sx={{ bgcolor: "#0088FF", marginLeft: 3 }}
              >
                Apply Leaves
              </Button>
            </>
          ) : (
            <>
              <Button
                sx={{ bgcolor: "#0088FF" }}
                variant="contained"
                onClick={() => setOpenApply(!openApply)}
              >
                Apply Leaves
              </Button>
            </>
          )}
        </div>
        {currentOrg.type == "Owner" ? (
          view === "card" ? (
            filteredRequests?.length > 0 ? (
              <GridView
                acceptLeave={acceptLeave}
                rejectLeave={rejectLeave}
                filteredRequests={filteredRequests}
              />
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",

                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    padding: "10px",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignContent: "center",
                    justifyContent: "center",

                    borderRadius: "12px",
                    color: "white",
                    marginBottom: "30px",
                    marginTop: "30px",
                  }}
                >
                  {/* Icon/Image Section */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={"/images/cuate.png"} // Replace with your actual image path
                      alt="No job applications"
                      sx={{ width: "278px", height: "150" }}
                    />
                  </Box>

                  {/* Main Text */}
                  <p
                    style={{
                      marginBottom: 1,
                      fontFamily: "sans-serif",
                      // fontSize: "22px",
                      fontWeight: "600",
                    }}
                    className={`text-[16px] md:text-[22px] mt-2`}
                  >
                    No Pending Application Yet
                  </p>
                  <p
                    // style={{ marginBottom: 4, fontSize: "16px" }}
                    // className={`${mode === "light" ? "text-[#000]" : "text-[#fff]"
                    //   } mt-2 mb-2`}
                    className="text-[14px] md:text-[16px] text-[#868686] text-center w-[90%] md:w-[70%] m-auto my-3"
                  >
                    You do not have any recent leave applications. When you add
                    employees and they apply for leaves, it will show here.
                  </p>

                  <button
                    className="w-[110px] h-[32px] flex justify-center
                   items-center text-[14px] cursor-pointer bg-[#0088ff] mx-auto rounded-md mt-2"
                    onClick={() => setleaveModal(true)}
                  >
                    Apply Leave
                  </button>

                  {leaveModal && (
                    <LeaveModal
                      leaveModal={leaveModal}
                      setleaveModal={setleaveModal}
                    />
                  )}
                </Box>
              </Box>
            )
          ) : (
            <LeaveViewPage
              LeaveDetails={LeaveDetails}
              leaveAppData={filteredRequestslist}
              setRowsPerPage={setRowsPerPage}
              setPage={setPage}
              rows={rows}
              page={pages}
              paginationModel={paginationModel}
              rowsPerPage={rowsPerPage}
            />
          )
        ) : (
          <LeaveViewPage
            LeaveDetails={LeaveDetails}
            leaveAppData={filteredRequestslist}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            page={pages}
            rows={rows}
            rowsPerPage={rowsPerPage}
            paginationModel={paginationModel}
          />
        )}
      </Box>

      {/* <Modal
        open={openApply}
        onClose={() => setOpenApply(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <>
          <ApplyLeaves fetchLeaveApplication={fetchLeaveApplication} handleClose={() => setOpenApply(false)} />
        </>
      </Modal> */}
      <ApplyLeaveModal
        openApply={openApply}
        setOpenApply={setOpenApply}
        isteam={isteam}
      />

      <ExportModal
        open={exportOpen}
        handleClose={() => setExportOpen(false)}
        tableData={mappedLeaveData}
      />
      <ImportModal
        open={openImportModal}
        handleDone={handleDone}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        handleClose={handleClose}
      />
    </Box>
  );
};

export default LeaveAppPage;
